module.exports = __webpack_public_path__ + "static/media/IMG-6.370a2188.jpg";